import $ from 'jquery';
import jqueryColor from 'jquery-color';

let NavFlagDic = {};

let _aboutItemAniIdAry = ['worldwide_id', 'boundless_id', 'imagining_id', 'three_boxs_id', 'apj_logo_id'];

export function scrollToTop(pageId) {
    $("#" + pageId).animate({
        scrollTop: 0,
    }, "slow");
}

export function addPageScrollListener(pageId, navId, offsetHight, sectionIdAry) {
    NavFlagDic.navId = { value: 0 };
    $("#" + pageId).on('scroll', () => {
        processScroll(pageId, navId, offsetHight, sectionIdAry, _aboutItemAniIdAry);
    });

    //添加时就检查一下
    processScroll(pageId, navId, offsetHight, sectionIdAry, _aboutItemAniIdAry);
}

//切换语言用
export function reloadAni(){
    checkFromBottmAni(_aboutItemAniIdAry);
}

function processScroll(pageId, navId, offsetHight, sectionIdAry, aboutItemAniIdAry) {
    checkNavColor(pageId, navId, offsetHight);

    //sectin view 初次显示动画
    if (sectionIdAry && sectionIdAry.length > 0) {
        checkSectionViewAni(sectionIdAry);
    }

    //从底部显示动画
    if (aboutItemAniIdAry && aboutItemAniIdAry.length > 0) {
        checkFromBottmAni(aboutItemAniIdAry);
    }
}

function checkFromBottmAni(aboutItemAniIdAry) {
    aboutItemAniIdAry.forEach(elId => {
        if (isFirstShowing(elId)) {
            $('#' + elId).addClass('bottom_ani_class50');
        }
    });
}

function checkSectionViewAni(sectionIdAry) {
    sectionIdAry.forEach(sectionId => {
        if (isFirstShowing(sectionId + '_left')) {
            $('#' + sectionId + '_left').addClass('section_left_ani_class100');
        }
        if (isFirstShowing(sectionId + '_right')) {
            $('#' + sectionId + '_right').addClass('section_right_ani_class10');
        }
    });
}

export function checkNavColor(pageId, navId, offsetHight) {
    let h = offsetHight ? offsetHight : 130;
    let x = $("#" + pageId).scrollTop();
    if (x > h - 10) {
        setNavColor(navId, true);

    } else if (x <= h + 10) {
        setNavColor(navId, false);
    }
}

export function setNavColor(navId, isBlack) {
    if (isBlack && NavFlagDic.navId.value == 0) {
        NavFlagDic.navId.value = 1;
        $("#" + navId).animate({
            backgroundColor: "#000000dd",
        }, 200);
    } else if (!isBlack && NavFlagDic.navId.value == 1) {
        NavFlagDic.navId.value = 0;
        $("#" + navId).animate({
            backgroundColor: "#00000000",
        }, 200);
    }
}

export function isShowing(elId) {
    try {
        if (elId == null || elId == undefined || elId == '') {
            return false;
        }

        let el = $('#' + elId)[0];
        if (el) {
            let h = $(window).height();
            let top = el.getBoundingClientRect().top;
            return top < (h - 100) && top > -el.offsetHeight;
        } else {
            return false;
        }
    } catch (e) {
        console.log(e);
        return false;
    }
}

export function isFirstShowing(elId) {
    if (elId == null || elId == undefined || elId == '') {
        return false;
    }
    if ($('#' + elId).hasClass('first_showing_class')) {
        return false;
    }
    if (isShowing(elId)) {
        $('#' + elId).addClass('first_showing_class');
        return true;
    };
    return false;
}


export function isEmail(str) {
    if (isEmpty(str) || str.length < 1 || str.length > 255) {
        return false;
    }
    return str.match('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}');
}

export function isEmpty(str) {
    if (str === null || str === undefined || !str || str == "" || 'undefined' == str || 'null' == str) {
        return true;
    }
    return false;
}

export function getImgPath(name) {
    if(isEmpty(name)){
        return '';
    }
    if(name.indexOf('game-cdn.aplusjapan-game.com') != -1){
        return name;
    }
    return 'https://game-cdn.aplusjapan-game.com/aplus_official/img/' + name;
}

export function saveLocalString(key, value) {
    if (typeof window !== 'undefined') {
        if (value == null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    }
}

export function saveSessionString(key, value) {
    if (typeof window !== 'undefined') {
        sessionStorage.setItem(key, value);
    }
}

export function getLocalString(key) {
    if (typeof window !== 'undefined') {
        const str = localStorage.getItem(key);
        if (isEmpty(str)) {
            return "";
        }
        return str;
    } else {
        return "";
    }
}

export function getSessionString(key) {
    if (typeof window !== 'undefined') {
        const str = sessionStorage.getItem(key);
        if (isEmpty(str)) {
            return "";
        }
        return str;
    } else {
        return "";
    }
}

export function removeLocalString(key) {
    if (typeof window !== 'undefined') {
        localStorage.removeItem(key);
    }
}

export function clearLocalString() {
    if (typeof window !== 'undefined') {
        localStorage.clear();
    }
}

export function getLang(){
    const l = getLocalString('local_lang');
    if('cn' == l || 'jp' == l){
        return l;
    }
    return 'en';
}